import { EnhancedModel } from '../enhanced.model';
import { Slot } from './slot.model';
import { Log } from '../../utils/log';
import { Utils } from '../../utils/utils';

export class DaySlots extends EnhancedModel {

    /**
     * "09:00"
     */
    private _slots:Array<Slot> = new Array<Slot>();
    public get slots():Array<Slot> {
        return this._slots;
    }
    public set slots(value:Array<Slot>) {
        this._slots = value;
    }

    private _morningSlots:Array<Slot> = new Array<Slot>();
    public get morningSlots():Array<Slot> {
        return this._morningSlots;
    }
    public set morningSlots(value:Array<Slot>) {
        this._morningSlots = value;
    }

    private _afternoonSlots:Array<Slot> = new Array<Slot>();
    public get afternoonSlots():Array<Slot> {
        return this._afternoonSlots;
    }
    public set afternoonSlots(value:Array<Slot>) {
        this._afternoonSlots = value;
    }

    /**
     * total remaining appointments within each slot
     */
    private _totalRemainingAppointements:number = 0;
    public get totalRemainingAppointements():number {
        return this._totalRemainingAppointements;
    }
    public set totalRemainingAppointements(value:number) {
        this._totalRemainingAppointements = value;
    }

    private _remainingMorningAppointments: number = 0;
    public get remainingMorningAppointments(): number {
        return this._remainingMorningAppointments;
    }
    public set remainingMorningAppointments(value: number) {
        this._remainingMorningAppointments = value;
    }

    private _remainingAfternoonAppointments: number = 0;
    public get remainingAfternoonAppointments(): number {
        return this._remainingAfternoonAppointments;
    }
    public set remainingAfternoonAppointments(value: number) {
        this._remainingAfternoonAppointments = value;
    }

    // convienance property for displaying time zone in the calandar popup
    private _tzData: string = '';
    public get timezone(): string {
        return this._tzData;
    } public set timezone(value: string) {
        this._tzData = value;
    }

    /**
     * Date by day ISO, example 2017-06-01
     */
    private _date:string = '';
    public get date():string {
        return this._date;
    }
    public set date(value:string) {
        this._date = Utils.extendYearMonthDayFormatToFullISO(value);
        if(this._date.length > 0) {
            if (Date.parse(this._date)) {
                this._dateObject = new Date(this._date);
                this._dateObject = Utils.getCleanDate(this._dateObject);
                let timeDiff:number = Date.now() - this._dateObject.getTime();
                let dayInMilliseconds:number = 24 * 60 * 60 * 1000;
                if(timeDiff > dayInMilliseconds) {
                    this.totalRemainingAppointements = 0;
                }
            }
        }
    }

    private _dateObject:Date = null;
    public get dateObject():Date {
        return this._dateObject;
    }

    constructor(obj: any = null) {
        super();
        if (obj !== null) {
            if (obj instanceof DaySlots) {
                this.mapClone(obj);
            } else {
                this.mapJson(obj);
            }
        }
    }

    public addSlot(slot: Slot) {
        this._slots.push(slot);
        this.totalRemainingAppointements += slot.available;
        if (slot.slotHour < 12) {
            this.morningSlots.push(slot);
            if (!slot.expired) {
                this.remainingMorningAppointments += slot.available;
            } else {
                this.totalRemainingAppointements -= slot.available;
            }
        } else {
            this.afternoonSlots.push(slot);
            if (!slot.expired) {
                this.remainingAfternoonAppointments += slot.available;
            } else {
                this.totalRemainingAppointements -= slot.available;
            }
        }
    }

    public sortSlots() {
        this.morningSlots.sort(this.slotSort);
        this.afternoonSlots.sort(this.slotSort);
        this._slots.sort(this.slotSort);
    }

    public clone() {
        let cloned = new DaySlots(this);
        return cloned;
    }

    protected mapClone(obj:DaySlots) {
        this._slots = obj.slots;
        this._totalRemainingAppointements = obj.totalRemainingAppointements;
        this._date = obj.date;
        this._remainingAfternoonAppointments = obj.remainingAfternoonAppointments;
        this._remainingMorningAppointments = obj.remainingMorningAppointments;
        this._tzData = obj.timezone;
    }

    protected mapJson(obj: any) {
        // Objct is maped via setting properties directly
        Log.warning('Object is mapped via setting poperties');
        // if (obj.hasOwnProperty('date')) {
        //     this.date = obj.date;
        // } else {
        //     Log.error('Date property not set on the day slot model');
        // }
        // if (obj.hasOwnProperty('slots')) {
        //     obj.slots.forEach((element:any) => {
        //         let slot:Slot = new Slot(element);
        //         slot.date = this.dateObject;
        //         this.totalRemainingAppointements += slot.available;
        //         if(slot.slotHour < 12) {
        //             this.morningSlots.push(slot);
        //         } else {
        //             this.afternoonSlots.push(slot);
        //         }
        //         this.slots.push(slot);
        //     });
        //     this.morningSlots.sort(this.slotSort);
        //     this.afternoonSlots.sort(this.slotSort);
        // }
    }

    private slotSort(a:Slot, b:Slot):number {
        if (a.date.getTime() > b.date.getTime()) {
            return 1;
        }
        if(a.date.getTime() < b.date.getTime()) {
            return -1;
        }
        return 0;
    }
}
